export default __webpack_public_path__ + "static/media/movies.c00fd31f.svg";